export const BENEFIT_MOCK = [
  {
    uid: '1',
    internalId: '',
    title: 'Extrarückreisekosten',
    description: '',
    valueSingleInland: 'zu 100 %',
    valueSingleAbroad: 'zu 100 %',
    valueFamilyInland: 'zu 100 %',
    valueFamilyAbroad: 'zu 100 %'
  },
  {
    uid: '6',
    internalId: '',
    title: 'Überführungs-/Bestattungskosten',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 22.000,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 44.000,-'
  },
  {
    uid: '11',
    internalId: '',
    title: 'Verspätungsschutz',
    description: '',
    valueSingleInland: '€ 1.000,-',
    valueSingleAbroad: '€ 1.000,-',
    valueFamilyInland: '€ 1.000,-',
    valueFamilyAbroad: '€ 1.000,-'
  },
  {
    uid: '16',
    internalId: '',
    title: 'Medizinische Leistungen, Unfallversicherung',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 250.000,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 500.000,-'
  },
  {
    uid: '21',
    internalId: '',
    title: 'Ambulante/Stationäre Behandlung',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: 'zu 100 %',
    valueFamilyInland: '-',
    valueFamilyAbroad: 'zu 100 %'
  },
  {
    uid: '26',
    internalId: '',
    title: 'Heim-Nottransporte chron. Erkrankungen, unerwartet akut',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 50.000,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 50.000,-'
  },
  {
    uid: '31',
    internalId: '',
    title: 'Heilkosten chron. Erkrankungen, unerwartet akut',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 15.000,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 15.000,-'
  },
  {
    uid: '36',
    internalId: '',
    title: 'Nottransport aus Ausland, Extrarückreise gesamte versicherte Familie / Begleitperson',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: 'zu 100 %',
    valueFamilyInland: '-',
    valueFamilyAbroad: 'zu 100 %'
  },
  {
    uid: '41',
    internalId: '',
    title: 'Wiederholungsreise',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 3.300,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 3.300,-'
  },
  {
    uid: '46',
    internalId: '',
    title: 'Todesfall',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 16.500,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 16.500,-'
  },
  {
    uid: '51',
    internalId: '',
    title: 'Bleibende Invalidität',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 33.000,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 33.000,-'
  },
  {
    uid: '56',
    internalId: '',
    title: 'Such-/Bergungskosten inkl. Helikopterbergung',
    description: '',
    valueSingleInland: '€ 11.000,-',
    valueSingleAbroad: '€ 11.000,-',
    valueFamilyInland: '€ 22.000,-',
    valueFamilyAbroad: '€ 22.000,-'
  },
  {
    uid: '61',
    internalId: '',
    title: 'Reisehaftpflichtversicherung',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 440.000,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 440.000,-'
  },
  {
    uid: '66',
    internalId: '',
    title: 'Dolmetschkosten',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 2.200,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 2.200,-'
  },
  {
    uid: '71',
    internalId: '',
    title: 'Rechtsbeistand im Ausland',
    description: '',
    valueSingleInland: '-',
    valueSingleAbroad: '€ 5.500,-',
    valueFamilyInland: '-',
    valueFamilyAbroad: '€ 5.500,-'
  },
  {
    uid: '76',
    internalId: '',
    title: 'Reisegepäck',
    description: '',
    valueSingleInland: '€ 2.200,-',
    valueSingleAbroad: '€ 2.200,-',
    valueFamilyInland: '€ 4.400,-',
    valueFamilyAbroad: '€ 4.400,-'
  },
  {
    uid: '81',
    internalId: '',
    title: 'Verspätete Gepäckauslieferung',
    description: '',
    valueSingleInland: '€ 220,-',
    valueSingleAbroad: '€ 220,-',
    valueFamilyInland: '€ 440,-',
    valueFamilyAbroad: '€ 440,-'
  },
  {
    uid: '86',
    internalId: '',
    title: 'Laptop (Diebstahl und Beraubung)',
    description: '',
    valueSingleInland: '€ 400,-',
    valueSingleAbroad: '€ 400,-',
    valueFamilyInland: '€ 400,-',
    valueFamilyAbroad: '€ 400,-'
  },
  {
    uid: '91',
    internalId: '',
    title: 'Sportgeräte (Diebstahl und Beraubung)',
    description: '',
    valueSingleInland: '€ 400,-',
    valueSingleAbroad: '€ 400,-',
    valueFamilyInland: '€ 800,-',
    valueFamilyAbroad: '€ 800,-'
  },
  {
    uid: '96',
    internalId: 'storno',
    title: 'Stornoschutz inkl. Reiseabbruch',
    description: '',
    valueSingleInland: '€ 3.000,-',
    valueSingleAbroad: '€ 3.000,-',
    valueFamilyInland: '€ 6.000,-',
    valueFamilyAbroad: '€ 6.000,-'
  }
];
